import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { savePreferenceSuccess as savePreferenceSuccessAction } from 'legacy-src/components/auth/actions';

/**
 * This was created to provide some common props to both the
 * SPPPlayerWrapper + VideoResourcePreviewWrapper components
 * centrally
 **/
export const VideoResourceWrapperCommonProps = (WrappedComponent) => {
  const CommonProps = (props) => {
    const { userData, subjectData, featureFlag, impersonating } = props;

    const { classes } = subjectData;
    const teacherClasses = (classes || []).filter(
      (section) =>
        section.educationPeriod.toString() ===
        userData.chosenEducationPeriodCode.toString(),
    );

    const apOutlineSearchFlag = featureFlag.AP_outline_search;
    const showZeroWatchedFlag = featureFlag.show_0pct_watched;
    const apTeacherImpersonatesStudent =
      featureFlag.ap_teacher_impersonates_student;

    const studentClasses = (userData.me.sections || []).filter(
      (section) =>
        section.masterSubjectId === subjectData.id &&
        section.educationPeriod ===
          userData.chosenEducationPeriodCode.toString(),
    );

    const isReadOnly = impersonating && impersonating.isReadOnly;
    const isImpersonating =
      Boolean(isReadOnly && apTeacherImpersonatesStudent) ||
      window.localStorage.getItem('isReadOnly') === 'true';

    const wrappedComponentProps = {
      teacherClasses,
      apOutlineSearchFlag,
      showZeroWatchedFlag,
      studentClasses,
      isImpersonating,
    };

    return <WrappedComponent {...wrappedComponentProps} {...props} />;
  };

  const mapStateToProps = ({
    userData,
    subject,
    classes: { items },
    featureFlag,
    impersonating,
  }) => ({
    userData,
    subjectData: subject.data,
    userClasses: items,
    featureFlag,
    impersonating,
  });

  return compose(
    withRouter,
    connect(mapStateToProps, {
      savePreferenceSuccess: savePreferenceSuccessAction,
    }),
  )(CommonProps);
};
